// extracted by mini-css-extract-plugin
var _1 = "GY1fcBuMCfMQyN4LhwFe";
var _2 = "u7UKIlps01FvjZdMhIxs";
export { _1 as "loadingRowRect", _2 as "loadingRowSpinner" }
